import ActivitiesFilter from "./components/filter";
import ClubActivitiesList from "./components/list";
import {useAuthContext} from "../../../Auth/provider/AuthProvider";
import {getActiveOrganisation} from "../../../Auth/services/organisationService";

const ClubActivities = () => {
  const { organisation } = useAuthContext();

  return (
    <div className="flex flex-col gap-8">
      {/*<RenderIf cond={!!organisation}>*/}
      {/*  <div className="-mx-4">*/}
      {/*    <ClubActivitiesNewList />*/}
      {/*  </div>*/}
      {/*</RenderIf>*/}
      <div className="xl:px-52">
        <ActivitiesFilter title={!!getActiveOrganisation() ? 'دوره‌های کانون' : 'دوره‌های نوجهان'} />
      </div>
      <div className="xl:px-52">
        <ClubActivitiesList commonGame={!getActiveOrganisation()} />
      </div>
    </div>
  );
};

export default ClubActivities;
